/**
 * adminBreadcrumbs.js
 *
 * `/admin/*` sayfalarında kullanılan PageHeader breadcrumb'ının kök
 * (ilk) kırıntısı için rol bazlı etiket/hedef üretir.
 *
 * Danışman rolü `/admin` panosuna erişemez (RoleRoute admin/superadmin'e
 * özel) — bu yüzden danışmana "Admin > ..." göstermek hem yanıltıcı hem
 * de tıklanırsa yetkisiz sayfaya yönlendirir. Danışman için kök etiket
 * "Danışman Paneli" olur ve kendi kokpit sayfasına (`/admin/cockpit`)
 * bağlanır.
 *
 * Kullanım:
 *   const { user } = useAuth();
 *   const tr = (t, e) => (lang === 'tr' ? t : e);
 *   <PageHeader breadcrumbs={[rootBreadcrumb(user?.role, tr), { label: '...' }]} ... />
 */
export function rootBreadcrumb(role, tr) {
  if (role === 'danisman') {
    return { label: tr('Danışman Paneli', 'Advisor Panel'), href: '/admin/cockpit' };
  }
  return { label: tr('Admin', 'Admin'), href: '/admin' };
}
